@if(disabled && showOnlyValueWhenDisabled)
{
<div class="py-[5px]">
    <div class="flex items-center" [ngClass]="boxHeight">
        <p class="text-sm font-medium text-black">{{ getSelectedOption(true) }}</p>
    </div>
</div>
}
@else {
<p class="mb-2 text-sm text-black mt-3" *ngIf="label !== ''">{{ label }}</p>

<!-- Ensure parent is relative -->
<div class="card flex justify-content-center w-full rounded-md border-1 relative"
    [ngClass]="[(errorMessage || warningMessage) ? 'border-error border-2' : 'border border-border', backgroundColor]">
    <div class="dropdown w-full text-black relative">
        <!-- Dropdown Button -->
        <div tabindex="0" role="button"
            class="btn w-full rounded-lg py-2 px-3 text-sm font-normal text-black focus:outline-none focus:ring-2 flex justify-between items-center overflow-hidden"
            [ngClass]="[focusColor, backgroundColor, boxHeight, disabled ? 'hover:cursor-not-allowed' : '', isTextAboveMaxLength ? '' : 'flex-nowrap']"
            [attr.aria-invalid]="errorMessage ? 'true' : null"
            [attr.aria-describedby]="errorMessage ? label + '-error' : null" (click)="toggleDropdown()"
            (keydown)="handleKeyDown($event)" [title]="getTitle">
            <div class="flex gap-2 items-center">
                <img *ngIf="trailingIcon" [src]="trailingIcon" [alt]="trailingIconAlt" class="w-5 h-5 ml-2" />
                <span [ngClass]="[selectedOption === undefined ? 'opacity-50' : '']">
                    {{ getSelectedOption() }}
                </span>
            </div>
            <img src="assets/icons/slider.svg" alt="ˇ" class="w-5 h-5" />
        </div>

        <!-- Dropdown List -->
        <div *ngIf="isDropdownOpen && !disabled" #dropdownMenu
            class="absolute left-0 top-full w-full bg-white text-black shadow-lg rounded-md z-50 border border-gray-300"
            style="max-height: 250px; overflow-y: auto; overflow-x: hidden;">

            <ul class="w-full">
                <li *ngFor="let option of options; let i = index" (click)="selectOption(i)"
                    [class.bg-neutral-200]="focusedIndex === i" class="cursor-pointer px-4 py-2 rounded-md w-full block"
                    (mouseenter)="focusedIndex = i">
                    <a class="block w-full">{{ option }}</a>
                    <button *ngIf="upgradeIncludes.includes(i)" [routerLink]="upgradeUrl"
                        class="ml-2 text-sm text-black hover:text-primary underline">
                        {{ 'shared.upgrade' | transloco }}
                    </button>
                </li>
            </ul>
        </div>
    </div>
</div>

<div *ngIf="errorMessage" [id]="label + '-error'" class="flex items-center text-error mt-2 text-sm">
    <img src="assets/icons/close-circle.svg" alt="{{ 'shared.components.error_icon' | transloco }}" class="w-5 h-5" />
    <p class="ml-1">{{ errorMessage }}</p>
</div>

<div *ngIf="!errorMessage && warningMessage" class="flex items-center text-error mt-2 text-sm">
    <img src="assets/icons/close-circle.svg" alt="{{ 'shared.components.error_icon' | transloco }}" class="w-5 h-5" />
    <p class="ml-1">{{ warningMessage }}</p>
</div>
}